import { ActionTypes } from "./constants";

const initialState = {
  data: [],
};

const mgtPermissionReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case ActionTypes.SET_DATA:
      return { ...state, data: payload };
    case ActionTypes.ADD:
      return {
        ...state,
        data: state.data.map((item) => {
          if (item.id == payload.group_id) {
            item.permissions = item.permissions.map((p) =>
              p.permission_id == payload.permission_id
                ? {
                    ...p,
                    acc: 1,
                  }
                : p
            );
            return item;
          } else {
            return item;
          }
        }),
      };
    case ActionTypes.REMOVE:
      return {
        ...state,
        data: state.data.map((item) => {
          if (item.id == payload.group_id) {
            item.permissions = item.permissions.map((p) =>
              p.permission_id == payload.permission_id
                ? {
                    ...p,
                    acc: 0,
                  }
                : p
            );
            return item;
          } else {
            return item;
          }
        }),
      };
    default:
      return state;
  }
};

export default mgtPermissionReducer;
